import React from 'react'

const BIinsightsData = () => {
  return (
    <div>BIinsightsData</div>
  )
}

export default BIinsightsData